var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBadgeWarning = function SvgBadgeWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#9C9A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33433 4.91934L7.06154 4.91934C7.05 4.12425 6.55365 3.4444 5.86106 3.1448C5.59557 3.02957 5.30699 2.98348 5.00687 2.995C4.59132 3.01805 4.19885 3.16785 3.88719 3.42135C3.72558 3.55963 3.48318 3.52506 3.35621 3.35221C3.24077 3.19089 3.2754 2.96043 3.42546 2.83368C3.80639 2.52256 4.27965 2.32667 4.78755 2.26905C5.15693 2.22296 5.52631 2.25753 5.86106 2.36124C6.9692 2.68388 7.78876 3.70943 7.8003 4.91934L8.52752 4.91934C8.56215 4.91934 8.58523 4.96543 8.56215 5L7.46555 6.49798C7.44247 6.52103 7.40784 6.52103 7.39629 6.49798L6.2997 5C6.27661 4.96543 6.2997 4.91934 6.33433 4.91934ZM1.50931 5C1.48622 5.03457 1.50931 5.08066 1.54394 5.08066L2.27115 5.08066C2.2827 6.29057 3.10226 7.31611 4.2104 7.63876C4.54515 7.73094 4.90298 7.77703 5.2839 7.73094C5.7918 7.67332 6.26507 7.46591 6.64599 7.16631C6.8076 7.03956 6.84222 6.8091 6.71525 6.64778C6.58828 6.47494 6.34587 6.44037 6.18427 6.57864C5.8726 6.83215 5.49168 6.98195 5.06459 7.00499C4.76446 7.01652 4.46434 6.9589 4.2104 6.85519C3.51781 6.56712 3.02145 5.88727 3.00991 5.08066L3.73713 5.08066C3.77176 5.08066 3.79484 5.03457 3.77176 5L2.67516 3.50201C2.65208 3.47897 2.61745 3.47897 2.6059 3.50201L1.50931 5Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBadgeWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/badge-warning.28162bec.svg";
export { ForwardRef as ReactComponent };